import { render, staticRenderFns } from "./detailBanners.vue?vue&type=template&id=518d440c&"
import script from "./detailBanners.vue?vue&type=script&lang=js&"
export * from "./detailBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports